import { createFileRoute, useSearch } from '@tanstack/react-router'
import { requireAuthBeforeLoad } from '@/features/auth/guards'
import { AppShell } from '@/features/app-shell/app-shell'
import { ProjectsCanvas } from '@/features/app-shell/canvases/projects-canvas'

type AppProjectsSearch = {
  type?: '' | 'clips' | 'captions' | 'dubbing' | 'video_cut'
}

export const Route = createFileRoute('/app/projects')({
  validateSearch: (search: Record<string, unknown>): AppProjectsSearch => ({
    type:
      search.type === 'clips' ||
      search.type === 'captions' ||
      search.type === 'dubbing' ||
      search.type === 'video_cut'
        ? search.type
        : undefined,
  }),
  beforeLoad: ({ location }) => requireAuthBeforeLoad({ location }),
  component: AppProjectsPage,
})

function AppProjectsPage() {
  const search = useSearch({ from: '/app/projects' })

  return (
    <AppShell activePath="/app/projects">
      <ProjectsCanvas initialTypeFilter={search.type} />
    </AppShell>
  )
}
